import React, { useState } from "react";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import QATicketApiService from "../../ApiServices/QATicketApiServices/QATicketApiService";
import { useAuth } from "../Auth/AuthContext";
import { motion } from "framer-motion";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "0",
        borderRadius: "8px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f9f9f9",
        width: "500px",
    },
};

const AddQATicketModalForm = ({ isOpen, closeModal }) => {
    const [formData, setFormData] = useState({
        Title: "",
        Description: "",
        Apporweb: "Playstore",
    });
    const [loading, setLoading] = useState(false);
    const { authState } = useAuth();
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const qaTicketData = {
            ...formData,
            UserId: authState.user.id,
        };

        try {
            const result = await QATicketApiService.Add(qaTicketData);
            toast.success(result.message);
            
            setTimeout(() => {
                toast.success("Please wait for admin to review your ticket. He will answer your query ASAP");
                setTimeout(() => navigate("/overview"), 2000);
            }, 2000);

            closeModal();
        } catch (error) {
            toast.error(error.message || "Error adding ticket");
            console.error("Add QATicket error:", error);
        } finally {
            setLoading(false);
        }
    };

    const customStyles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        content: {
            border: "none",
            background: "transparent",
            overflow: "hidden",
        },
    };

    return (
        <>
            <ToastContainer />
            <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles} ariaHideApp={false}>
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                className="bg-white backdrop-blur-lg rounded-lg shadow-xl p-6 max-w-md mx-auto relative border border-gray-200 mt-10"
            >
                {/* Close Button */}
                <button
                    onClick={closeModal}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition duration-200"
                >
                    ✖
                </button>

                {/* Title */}
                <h2 className="text-2xl font-semibold text-center mb-5 text-gray-800">Add QA Ticket</h2>

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-5">
                    {Object.keys(formData).map((field) => (
                        <div key={field} className="flex flex-col">
                            <label htmlFor={field} className="text-gray-700 font-medium mb-1 capitalize">
                                {field.replace(/([A-Z])/g, " $1")}
                            </label>
                            <input
                                type="text"
                                id={field}
                                name={field}
                                value={formData[field]}
                                onChange={handleInputChange}
                                className="border border-gray-300 rounded-md px-4 py-2 w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-gray-50"
                                placeholder={`Enter ${field}`}
                            />
                        </div>
                    ))}

                    {/* Buttons */}
                    <div className="flex justify-center space-x-4 mt-6">
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            type="submit"
                            className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all transform hover:scale-105 duration-300"
                        >
                            {loading ? "Adding..." : "Add QA Ticket"}
                        </motion.button>

                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            type="button"
                            onClick={closeModal}
                            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-400 transition-all transform hover:scale-105 duration-300"
                        >
                            Close
                        </motion.button>
                    </div>
                </form>
            </motion.div>
        </Modal>
        </>
    );
};

export default AddQATicketModalForm;
